var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33597 0.434634C6.73319 -0.144862 7.58916 -0.144894 7.98636 0.434634L9.8682 3.1817C9.99819 3.37128 10.1897 3.51022 10.4102 3.57526L13.6045 4.51666C14.2783 4.71546 14.5427 5.5292 14.1143 6.086L12.084 8.72467C11.9438 8.90688 11.8707 9.13157 11.877 9.36139L11.9678 12.6895C11.9871 13.3918 11.2958 13.8945 10.6338 13.6592L7.49613 12.544C7.27948 12.467 7.04286 12.467 6.8262 12.544L3.68851 13.6592C3.0265 13.8946 2.33423 13.3919 2.35355 12.6895L2.44534 9.36139C2.45159 9.13161 2.37848 8.90687 2.23831 8.72467L0.20804 6.086C-0.220437 5.52915 0.0438738 4.71535 0.717806 4.51666L3.91214 3.57526C4.13256 3.51018 4.32418 3.37127 4.45413 3.1817L6.33597 0.434634ZM10.1231 5.41413C9.89104 5.20149 9.5311 5.21731 9.31839 5.44928L6.86917 8.1192L5.48636 6.84284C5.25506 6.62934 4.89422 6.6438 4.6807 6.87506C4.46752 7.10632 4.48191 7.46629 4.71292 7.67975L6.51663 9.34479C6.62792 9.44731 6.77658 9.50247 6.92777 9.49616C7.07869 9.48962 7.22111 9.42288 7.32327 9.31159L10.1582 6.21881C10.3707 5.98689 10.3547 5.62685 10.1231 5.41413Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateVerified);
export default __webpack_public_path__ + "static/media/certificate-verified.bed16ec6af0d1189c734bfcea2197278.svg";
export { ForwardRef as ReactComponent };